(function($) {
	'use strict';

	/**
	 * Extract CCC mapping for a specific control UID prefix
	 * 
	 * This function searches through the Combined data structure to find
	 * all related control items that match the given control UID prefix
	 * and extracts their CCC mappings.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @param {string} controlUidPrefix - The control UID prefix to search for
	 * @param {string} year - The year to process (defaults to "2025")
	 * @returns {Array} Array of CCC mapping values
	 */
	function extractCCCMapping(data, controlUidPrefix, year = "2025") {
		// Validating structure as previously explained
		if (!data.Combined) {
			console.error("Data structure is not as expected.");
			return [];
		}

		// Escape parentheses in the controlUidPrefix for use in regex
		const escapedControlUidPrefix = controlUidPrefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		const regex = new RegExp(`^${escapedControlUidPrefix}(\\D|$)`); // Match controlUidPrefix followed by a non-digit or end of string
		
	// Always use the flat structure since we're using the current assessment's quality data
	// The year parameter is now only used for filtering within relatedCSItems if needed
	let allRelatedCSItems = [];
	
	if (Array.isArray(data.Combined)) {
		// Flat structure (current approach)
		allRelatedCSItems = data.Combined.flatMap(item => item.relatedCSItems || []);
	} else if (data.Combined[year]) {
		// Year-specific structure (legacy fallback for old data format)
		allRelatedCSItems = data.Combined[year].flatMap(item => item.relatedCSItems || []);
	} else {
		console.warn(`Unable to extract CCC mappings - Combined data structure not recognized`);
		return [];
	}

		return allRelatedCSItems.filter(item => {
			// Handle both DynamoDB format (.S) and direct format
			const controluid = item.controluid?.S || item.controluid;
			return controluid && regex.test(controluid);
		}).flatMap(item => {
			// Handle both DynamoDB format (.S) and direct format
			const cccMapping = item.cccmapping?.S || item.cccmapping;
			if (!cccMapping) return [];

			// Handle multi-line CCC mappings by splitting on newlines and trimming
			const mappings = cccMapping.split(/\s*\\n\s*|\s*\n\s*/).filter(id => id.trim());
			// console.log(`Parsed CCC mapping "${cccMapping}" into:`, mappings);
			return mappings;
		});
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractCCCMapping };
	} else if (typeof window !== 'undefined') {
		window.extractCCCMapping = extractCCCMapping;
	}

})(jQuery);
